import * as React from "react";
import { Button, Popover } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { formSet, formSetValue, formTriggerValidation, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { store } from "../../../../store";
import { FormListFieldItem } from "../../../gvc/formListFieldItem";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpSelect } from "../../../gvc/testNewForm/CpSelect";
import { HttpInboundHeaderFilterInput } from "../../../../schema/types/workload/input";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";

interface Props {
  name?: string;
  item?: HttpInboundHeaderFilterInput;
  index?: number;
}
export const CpArrayItemHttpInboundHeaderFilter: React.FC<Props> = React.memo(
  ({ name: _name, item: _item, index: _index }) => {
    const { id } = useCpFormContext();

    const name = _name!;
    const item = _item!;
    const index = _index!;

    // TODO improve this, should show only once even if there are multiple items
    // const headerFilterInputHelperIsShown = useCpFormValue(`firewallConfig.external.headerFilterInputHelperIsShown`);

    function remove() {
      const form = store.getState().form.instances[id];
      const values = form.values;
      const items = get(values, name) || [];
      let _items = cloneDeep(items);
      _items = _items.filter((i) => i.id !== item.id);
      formSetValue(id, name, _items);

      formTriggerValidation(id);
    }

    return (
      <FormListFieldItem columnCount={12} hasRemoveButton className="mb-1">
        <CpInput name={`${name}.${index}.key`} className="col-span-2" />
        <CpSelect
          name={`${name}.${index}.type`}
          className="col-span-2"
          options={[
            { label: "Allowed", value: "allowed" },
            { label: "Blocked", value: "blocked" },
          ]}
        />
        {/* <Popover
          content={
            <div>
              <div>Type regex value here and press Enter. Accepts multiple values.</div>
              <span
                className="cursor-pointer color-link"
                onClick={() => {
                  formSetValue(`firewallConfig.external.headerFilterInputHelperIsShown`, true);
                }}
              >
                Close
              </span>
            </div>
          }
          title="Title"
          trigger="click"
          open={!headerFilterInputHelperIsShown}
        > */}
        <CpSelect
          name={`firewallConfig.external.httpInboundHeaderFilter.${index}.values`}
          mode={`tags`}
          // TODO re2 regex validation
          notFoundContent={`Type values and press enter, this field allows multiple string values`}
          className={`col-span-8`}
        />
        {/* </Popover> */}
        <Button type={`text`} danger icon={<MinusCircleOutlined />} onClick={() => remove()} />
      </FormListFieldItem>
    );
  },
);
